import { useState, useEffect } from "react"
import { usePage } from "@inertiajs/react"
import SadPandaModal from "@/Components/SadPandaModal"

export default function ErrorModalWrapper({ children }) {
  const { props } = usePage()
  const [error, setError] = useState(null)

  useEffect(() => {
    if (props.errorModal) {
      setError(props.errorModal)
    }
  }, [props.errorModal])

  return (
    <>
      {children}
      <SadPandaModal error={error} onDismiss={() => setError(null)} />
    </>
  )
}
